import http from '@frontend/api/http';

import { TurnstileInstance, TurnstileInstanceUpdate } from '../types';

export const getConnections = async (instanceId: string) => {
  const response = await http.get<TurnstileInstance[]>(
    `/backend/api/v1/user/instances/${instanceId}/connections`
  );

  return response.data;
};

export const getSelfConnections = async (instanceId: string) => {
  const response = await http.get<TurnstileInstance[]>(
    `/backend/api/v1/user/instances/${instanceId}/connections/self`
  );

  return response.data;
};

export const updateConnections = async (instanceId: string, updates: TurnstileInstanceUpdate[]) => {
  const response = await http.patch<TurnstileInstance[]>(
    `/backend/api/v1/user/instances/${instanceId}/connections`,
    updates
  );

  return response.data;
};
